<template>
    <el-table
        :data="list"
        border
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column v-if="selection" align="center" type="selection" width="55"></el-table-column>
        <el-table-column
            v-for="(col, cindex) in cols"
            :key="cindex"
            :resizable="false"
            v-bind="col.attrs">
            <template slot-scope="scope">
                <slot v-if="col.slot" :name="col.prop + 'Slot'" v-bind="scope"></slot>
                <template v-else>{{ scope.row[col.prop] }}</template>
            </template>
        </el-table-column>
        <el-table-column
            v-if="hasCols('price')"
            label="价格"
            prop="price">
            <template slot-scope="scope">
                <el-input 
                    type="text"
                    :value="scope.row.price"
                ></el-input>
            </template>
            <template slot="header" slot-scope="scope">
                <span style="color: red;">*</span>
                <span>价格</span>
            </template>
        </el-table-column>
        <el-table-column
            v-if="hasCols('code')"
            label="商家编码"
            prop="code">
            <template slot="header" slot-scope="scope">
                <span style="color: red;">*</span>
                <span>商家编码</span>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>

export default {
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        },
        cols: {
            type: Array,
            default() {
                return [];
            }
        },
        selection: {
            type: Boolean,
            default: false
        },
        colsHas: {
            type: Array,
            default() {
                return ['price', 'code'];
            }
        }
    },
    methods: {
        handleSelectionChange(selection) {
            this.$emit("selection-change", selection);
        },
        hasCols(name) {
            return this.colsHas.indexOf(name) !== -1;
        }
    }
}
</script>

<style lang="scss">
</style>